import { motion } from 'framer-motion';
import { scrollToId } from '../lib/scroll';

const lineVariants = {
    hidden: { y: '110%' },
    visible: (i) => ({
        y: '0%',
        transition: { duration: 0.9, delay: 0.2 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
    }),
};

const MaskedLine = ({ children, index }) => (
    <span className="block overflow-hidden">
        <motion.span className="block" custom={index} variants={lineVariants} initial="hidden" animate="visible">
            {children}
        </motion.span>
    </span>
);

const fadeUp = (delay) => ({
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { delay, duration: 0.8, ease: [0.22, 1, 0.36, 1] },
});

export const Hero = () => (
    <section className="relative pt-32 md:pt-40 pb-8 md:pb-12 overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <motion.img
                src="/logo-ah.png"
                alt=""
                className="w-[420px] md:w-[600px] opacity-[0.05] select-none"
                animate={{ y: [0, -14, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
            />
        </div>
        <div
            className="absolute top-10 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-[0.07] pointer-events-none"
            style={{ background: 'radial-gradient(circle, #7A1228 0%, transparent 70%)' }}
        />
        <motion.span
            className="absolute left-[12%] top-40 text-rose/30 text-xl pointer-events-none"
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
        >
            ✦
        </motion.span>
        <motion.span
            className="absolute right-[14%] top-56 text-rose/25 text-sm pointer-events-none"
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut', delay: 1 }}
        >
            ✦
        </motion.span>
        <motion.span
            className="absolute right-[24%] bottom-24 text-ink/20 text-lg pointer-events-none"
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut', delay: 2 }}
        >
            ✦
        </motion.span>
        <div className="max-w-[880px] mx-auto px-6">
            <div className="relative z-10 py-8 md:py-14 text-center">
                <motion.div {...fadeUp(0.1)} className="mb-8" data-testid="hero-role-label">
                    <p style={{ fontFamily: "'Great Vibes', cursive" }} className="text-3xl md:text-4xl text-rose">
                        Adriana Hernández
                    </p>
                    <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.35em] text-ink/50">Personal Trainer · Fitness Coach</p>
                </motion.div>

                <h1 className="font-serif font-light leading-[1.06] text-[clamp(2.3rem,6vw,4rem)] text-ink" data-testid="hero-title">
                    <MaskedLine index={0}>Construye tu fuerza,</MaskedLine>
                    <MaskedLine index={1}>fortalece tu disciplina,</MaskedLine>
                    <MaskedLine index={2}>
                        alcanza tu <span className="italic text-rose">mejor versión</span>.
                    </MaskedLine>
                </h1>

                <motion.p
                    {...fadeUp(0.8)}
                    className="mt-7 text-base md:text-lg text-[#4A4744] font-light max-w-[620px] mx-auto"
                    data-testid="hero-description"
                >
                    Construye tu mejor versión con un plan hecho para ti, según tus objetivos, tu ritmo y tu estilo de
                    vida. Voy a estar a tu lado acompañándote durante todo el proceso, guiándote y ayudándote a sacar tu
                    mejor versión, aun en los días en que cuesta un poquito más. Tú pones las ganas y yo te ayudo a
                    convertirlas en resultados.
                </motion.p>

                <motion.div {...fadeUp(1)}>
                    <button
                        data-testid="hero-cta-button"
                        onClick={() => scrollToId('#contacto')}
                        className="mt-9 rounded-full bg-rose text-white px-9 py-4 text-base font-medium tracking-wide shadow-lg shadow-rose/25 hover:bg-roselight hover:-translate-y-px hover:shadow-xl hover:shadow-rose/30 active:scale-95 transition"
                    >
                        Quiero comenzar
                    </button>
                </motion.div>

            </div>
        </div>

        <div className="h-16 md:h-24" />
    </section>
);
